module.exports = __webpack_public_path__ + "img/logo_inside_sm.55000b0f.png";